// extracted by mini-css-extract-plugin
module.exports = {"root":"MainIdea_root__MdfKv","title":"MainIdea_title__R5gng","desc":"MainIdea_desc__jBitm"};